import { Check } from "lucide-react";
import { WHY_CHOOSE_US } from "@/lib/site";

export default function WhyChoose() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-24 md:py-32 bg-gradient-to-b from-[#0B1120] via-[#0d1428] to-[#0B1120]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-orange-500" />
              <span className="font-tech text-orange-400 text-xs">WHY MASTER READY</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
              <span className="chrome-text">Built for the</span>
              <br />
              <span className="ember-text">Close.</span>
            </h2>
            <p className="mt-6 font-body text-slate-400">
              Eight principles that separate our pipeline from a list of cold names.
            </p>

            <div className="hidden lg:block mt-10 forge-card p-6">
              <Check size={20} className="text-orange-400 mb-3" />
              <p className="font-body text-slate-300 text-sm">
                Whether you're a small contractor looking for a few quality opportunities
                each week — or an established company scaling into new markets — we build
                the pipeline with you.
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2">
              {WHY_CHOOSE_US.map((item, i) => (
                <div
                  key={item.num}
                  data-testid={`why-item-${item.num}`}
                  className={`group py-6 border-b border-white/5 ${
                    i % 2 === 0 ? "md:pr-6" : "md:pl-6"
                  }`}
                >
                  <div className="flex items-start gap-5">
                    <div className="font-display text-3xl md:text-4xl text-slate-700 group-hover:text-orange-500/70 transition-colors tracking-tight">
                      {item.num}
                    </div>
                    <div className="flex-1">
                      <h3 className="font-display text-xl tracking-tight text-slate-100 group-hover:text-white transition-colors">
                        {item.title}
                      </h3>
                      <p className="font-body text-slate-400 text-sm mt-1.5 leading-relaxed">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
